import { ClipboardIcon, OccupationIcon, UserMinusIcon } from "@/icons/solid";
import { Actions as EMPLOYEE_ACTIONS } from "@/redux/actions/employeeActions";
import { format, parse } from "date-fns";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const formatDate = (date) => {
	if (!date) return "Unknown Start Date";
	return format(parse(date, "yyyy-MM-dd", new Date()), "do MMM, yyyy");
};

function Occupation({ occupation, isAdmin, terminateOccupationModal }) {
	return (
		<li className="list-none px-12 py-2 my-2 bg-white rounded-2xl flex justify-between items-center">
			<Link
				className="text-black flex justify-start items-center"
				to={`../roles/${occupation?.value}/role`}
			>
				<OccupationIcon className="h-12 w-12" />
				<div className="px-4">
					<h3 className="text-3xl">
						{occupation?.role}
						<span className="text-2xl"> | {occupation?.department}</span>
					</h3>
					<span className="text-xl font-semibold text-gray-400">
						{occupation?.start && occupation?.end ? "From: " : "Since: "}
						<time dateTime={occupation?.start}>{formatDate(occupation?.start)}</time>
						{occupation.end ? (
							<>
								<span> until </span>
								<time dateTime={occupation?.end}>{formatDate(occupation?.end)}</time>
							</>
						) : null}
					</span>
				</div>
			</Link>
			<div className="flex gap-2">
				{!occupation?.end ? (
					<button
						className="btn-danger btn-xs btn"
						type="button"
						onClick={() => {
							terminateOccupationModal(occupation);
						}}
					>
						<UserMinusIcon className="h-6 w-6 mr-2 align-text-bottom" />
						Terminate
					</button>
				) : null}
				{isAdmin && occupation ? (
					<>
						<button
							className="btn-default btn-xs btn"
							type="button"
							onClick={() => {
								copyToClipboard(occupation?.value);
							}}
						>
							<ClipboardIcon className="h-5 w-5 align-text-bottom" />
						</button>
					</>
				) : null}
			</div>
		</li>
	);
}

const mapStateToProps = (state, ownProps) => {
	return {
		isAdmin: state.my?.profile?.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	terminateOccupationModal: (occupation) => dispatch(EMPLOYEE_ACTIONS.terminateOccupationModal(true, occupation)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Occupation);
